/* Etiquetas multiidoma en castellano. */
export default {
  "cancelConditionsViewer.dialog.title": "Cancellation policy",
  "cancelConditionsViewer.title": "Cancellation policy",
};
